export default __webpack_public_path__ + "static/media/atualizar.f6e86278.svg";